export default __webpack_public_path__ + "static/media/guide0105.008d56e7.jpg";